import { useDate } from 'Globals/useDate'
import { Button } from 'components/Button'
import { ChartFrame } from 'components/ChartFrame'
import { global_locales } from 'components/constants'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const locales = global_locales.summarytext

export const SummaryText = ({
  colorMode = 'light',
  lang = 'de',
}: {
  colorMode?: 'dark' | 'light' | undefined
  lang?: 'de' | 'fr'
}) => {
  const [text, setText] = useState<string | undefined>()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const endDate = useDate()

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard-2023/summary_texts.json'
    )
      .then((a) => a.json())
      .then((a) => {
        var placeholder_text = {
          de: ' Sowohl die Grippewelle als auch die Covid-19-Welle vom letzten Winter 2023/2024 sind seit Ende April abgeklungen. Das BAG überwacht weiterhin die epidemiologische Lage der respiratorischen Viren. Die Situationsbeurteilung ist aber aufgrund der tiefen Fallzahlen aktuell pausiert. Bei allfälligen Änderungen der Lage finden Sie hier aktuelle Informationen. Die planmässige Wiederaufnahme der Berichterstattung erfolgt zu Beginn der nächsten Virensaison in der Woche 40/2024.',
          fr: "La vague de grippe et de Covid-19 de l'hiver dernier 2023/2024 s'est calmée depuis fin avril. L'OFSP surveille toujours la situation épidémiologique des virus respiratoires. L'évaluation de la situation est actuellement en pause en raison du faible nombre de cas. En cas de changement de situation, vous trouverez ici des informations actuelles. La reprise planifiée de la communication aura lieu au début de la prochaine saison virale, à la semaine 40/2024.",
        }
        /*
       

        */
        setText(a[lang] ? a[lang] : placeholder_text[lang])
      })
  }, [lang])

  return (
    <ChartFrame
      lang={lang}
      timestamp={
        <>
          {new Date(endDate).toLocaleDateString(lang + '-CH', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })}{' '}
          {locales[lang].frequency}
        </>
      }
      title={locales[lang].title}
      source={locales[lang].source}
    >
      <SummaryTextRoot>
        {text && (
          <TextContainer
            colorMode={colorMode}
            dangerouslySetInnerHTML={{ __html: text }}
            isOpen={isOpen}
          />
        )}
        <ButtonContainer>
          <Button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? locales[lang].showLess : locales[lang].showMore}
          </Button>
        </ButtonContainer>
      </SummaryTextRoot>
    </ChartFrame>
  )
}

const SummaryTextRoot = styled.div`
  line-height: 1.5em;
`
const Label = styled.div`
  font-size: 15px;
  opacity: 0.8;
  margin-bottom: 15px;
  font-weight: 700;
`
const TextContainer = styled.div<{
  isOpen: boolean
  colorMode: 'dark' | 'light' | undefined
}>`
  width: 100%;
  max-height: ${(props) => (props.isOpen ? '1200px' : '200px;')};
  transition: max-height 0.3s ease-in-out;
  overflow-y: hidden;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${(props) => (props.isOpen ? '0px' : '200px;')};
    background: ${(props) =>
      props.colorMode === 'dark'
        ? 'linear-gradient(180deg,rgba(18, 18, 18, 0) 0%,rgba(18, 18, 18, 1) 100%)'
        : 'linear-gradient(180deg,rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 1) 100%)'};
  }
`
const ButtonContainer = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 20px;
`
